import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService, SelectItemGroup } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { SplitButtonModule } from 'primeng/splitbutton';

import { CreateStockDTO, Stock, StockItemDTO } from 'src/app/domain/stock';
import { Opportunities } from 'src/app/services/opportunitiesPage/opportunities';
import { Customer, CustomerService } from 'src/app/shared/services/customer.service';
import { OpportunityorderService } from 'src/app/shared/services/opportunityorder.service';
import { Category, Item, ProductResponse, ProductsService, Type } from 'src/app/shared/services/products.service';
import { StockService } from 'src/app/stock.service';
import { saveAs } from 'file-saver';
import { Table } from 'primeng/table';
import autoTable from 'jspdf-autotable';
import { SpinnerServiceService } from 'src/app/shared/services/spinner-service.service';

import jsPDF from 'jspdf';
import { SalesRepService } from 'src/app/shared/services/sales-rep.service';
import { SalesService, Users } from 'src/app/shared/services/sales.service';
import { AccessLevelEnum, ApplianceRole, AuthenticationService, CadenceRole } from 'src/app/services/authentication/authentication.service';
import { LoggingUser, UserConfigService } from 'src/app/shared/services/user-config.service';

@Component({
  selector: 'app-stocks',
  templateUrl: './stocks.component.html',
  styleUrls: ['./stocks.component.scss'],
  providers: [MessageService, ConfirmationService],

})
export class StocksComponent implements OnInit {
  @ViewChild('dt6') table: Table;

  myForm: FormGroup;
  stockDialog: boolean = false;
  visible: boolean = false;
  itemsDialog: boolean = false;
  hasCoverage: Boolean = false;
  submitted: boolean = false;
  visibleCustomerOptions: any[] = [];
  totalRecords: number = 0;
  selectedCustomer: any;
  selectedCustomerId: number;
  selectedstockCoverageStartDate: any;
  selectedstockCoverageEndDate: any;
  selectedPurchaseDate: any;
  selectedBatchNumber: string;
  selectedQuantity: number;
  selectedPoNumber: number;
  UserOptions: Users[] = [];
  today: Date = new Date(); // for primeNg calendar component
  currentUser: LoggingUser;

  selecteCategory: any;
  selectedType: any;
  selectedItem: any;

  selectedStockOwner: any;
  customerOptions: Customer[] = [];
  selectedOpportunity: any;
  selectedStatus: number = 1;
  selectedPrice: number;
  dialogTitle: string = 'Add Stock';
  stockItems: StockItemDTO[] = [];
  originalStockItems: StockItemDTO[] = [];
  opportunityOptions: Opportunities[] = [];


  categoriesByKind: any[] = [];
  licenseCategories: Category[] = [];
  serviceCategories: Category[] = [];
  productsResponse: ProductResponse;
  groupedCategories: SelectItemGroup[] = [];
  typesByCategory: Type[] = [];
  itemsByType: Item[] = [];
  filteredStockIds: number[] = [];


  stock: Stock = {
    stockId: 0,
    batchNumber: '',
    quantity: 0,
    poNumber: 0,
    stockCoverageStartDate: null,
    stockCoverageEndDate: null,
    customerId: 0,
    customerName: '',
    customerNumber: '',
    productId: null,
    productKind: null,
    categoryName: null,
    itemName: null,
    productTypeName: null,
    opportunity: { id: 0, opportunityName: '' },
    status: 1,
    price: 0,
    availableQuantity: 0,
    stockOwner: '',
    stockOwnerId: 0,
    purchaseDate: null,
    rabet: false,
    customerStock: false
  };


  excelItems: MenuItem[];
  pdfItems: MenuItem[];

  formatDate(date: Date): string {
    let format = formatDate(date, 'yyyy-MM-dd', 'en-US');

    return format;
  }


  saveStock(): void {
    SpinnerServiceService.showSpinner();
    
    if (this.hasCoverage) {
      if (!this.selectedstockCoverageStartDate) {
        // Show error message
        this.messageService.add({
          severity: 'error', 
          summary: 'Error', 
          detail: 'Coverage start date is required when Has Coverage is checked'
        });
        SpinnerServiceService.hideSpinner(); // Hide spinner before returning
        return;
      }
      
      if (!this.selectedstockCoverageEndDate) {
        // Show error message
        this.messageService.add({
          severity: 'error', 
          summary: 'Error', 
          detail: 'Coverage end date is required when Has Coverage is checked'
        });
        SpinnerServiceService.hideSpinner(); // Hide spinner before returning
        return;
      }
    }
    
    const newStock: CreateStockDTO = {
      batchNumber: this.selectedBatchNumber ? this.selectedBatchNumber : null,
      quantity: this.selectedQuantity ? this.selectedQuantity : null,
      poNumber: this.selectedPoNumber ? this.selectedPoNumber : null,
      stockCoverageStartDate: this.selectedstockCoverageStartDate ? this.formatDate(this.selectedstockCoverageStartDate) : null,
      stockCoverageEndDate: this.selectedstockCoverageEndDate ? this.formatDate(this.selectedstockCoverageEndDate) : null,
      customerId: this.selectedCustomerId ? this.selectedCustomerId : null,
      productId: this.stock.productId ? this.stock.productId : null,
      status: this.selectedStatus ? this.selectedStatus : null,
      price: this.selectedPrice ? this.selectedPrice : null,
      opportunityId: this.stock.opportunity?.id ? this.stock.opportunity.id : null,
      stockOwnerId: this.selectedStockOwner ? this.selectedStockOwner : 1,
      purchaseDate: this.selectedPurchaseDate ? this.formatDate(this.selectedPurchaseDate) : null,
      rabet: this.stock.rabet,
      customerStock: !this.stock.customerStock,
      creatorEmail: this.currentUser.email,
    };
    
    if (this.dialogTitle === 'Add Stock') {
      this.stockService.addStock(newStock).subscribe(
        (response: Stock) => {
          this.stocks.unshift(response);
          this.stocks = [...this.stocks];
          this.messageService.add({ severity: 'info', summary: 'Stock Created', detail: 'The Stock created successfully!' });
          this.closeDialog();
          SpinnerServiceService.hideSpinner();
        },
        (error) => {
          console.error('Error adding stock:', error);
          SpinnerServiceService.hideSpinner();
        }
      );
    } else {
      this.updateStock(this.editableStock!.stockId, newStock);
      this.updateStock(this.editableStock!.stockId, newStock);
    }
    SpinnerServiceService.hideSpinner();


  }
  saveStockItems() {
    const changedItems = this.stockItems
      .filter((item, index) => JSON.stringify(item) !== JSON.stringify(this.originalStockItems[index]))
      .map(item => ({
        ...item,
        itemPurchaseDate: item.itemPurchaseDate ? new Date(this.formatDate(item.itemPurchaseDate)) : null,
        itemExpiryDate: item.itemExpiryDate ? new Date(this.formatDate(item.itemExpiryDate)) : null,
        grDate: item.grDate ? new Date(this.formatDate(item.grDate)) : null
      }));

    if (changedItems.length > 0) {
      this.stockService.updateStockItems(changedItems).subscribe(
        response => {
          this.closeDialog();
        },
        error => {
          // Handle error
        }
      );
    } else {
      this.closeDialog();
    }
  }


  statusOptions = [
    { label: 'Reserved', value: 1 },
    { label: 'On Hands', value: 2 }
  ];

  // roles
  applianceRole: ApplianceRole;
  cadenceRole: CadenceRole;
  public accessLevelEnum = AccessLevelEnum;


  statuses!: any[];
  rowForm!: NgForm;
  stocks: Stock[];

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private stockService: StockService,
    private customerService: CustomerService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private productService: ProductsService,
    private opportunityService: OpportunityorderService,
    private MessageService: MessageService,
    private salesService: SalesService,
    private user: UserConfigService,

    public authenticationService: AuthenticationService) {

    this.myForm = this.fb.group({
      items: this.fb.array([])
    });


    this.excelItems = [
      {
        label: 'Stock Report',
        icon: 'pi pi-file-excel',
        command: () => this.exportExcel()
      },
      {
        label: 'Stock Details Report',
        icon: 'pi pi-file-excel',
        command: () => this.getFilteredStocksItemsForExcel()
      }
    ];

    // PDF Export Options
    this.pdfItems = [
      {
        label: 'Stock Report',
        icon: 'pi pi-file-pdf',
        command: () => this.exportPdf()
      },
      {
        label: 'Stock Details Report',
        icon: 'pi pi-file-pdf',
        command: () => this.getFilteredStocksItemsForPdf()
      }
    ];
  }

  async ngOnInit(): Promise<void> {
    this.loadCurrentUser();

    this.loadStocks();
    this.applianceRole = this.authenticationService.getApplanceRole();
    this.cadenceRole = this.authenticationService.getCadenceRole();

    await this.customerService.retrieveAllCustomers().toPromise().then(
      response => {
        this.customerOptions = response;
        this.totalRecords = this.customerOptions.length;
      });

    this.loadCustomersLazy({ first: 0, rows: 38 });

    this.productService.getProductsByKind('all').subscribe((data: ProductResponse) => {
      this.productsResponse = data;
      this.categoriesByKind = this.transformCategories(data);


    });
    await this.salesService.retrieveMainData().toPromise().then(
      response => {
        this.UserOptions = response.map(user => ({
          ...user,
          fullName: `${user.firstName} ${user.lastName}`
        }));
      });

  }
  loadCurrentUser() {
    this.user.getLoggingUser().subscribe(
      (user) => {
        this.currentUser = user;

      }
    );
  }
  loadStocks(): void {
    SpinnerServiceService.showSpinner();
    this.stockService.getLastTenStocks().subscribe(
      (lastTenStocks: Stock[]) => {
        this.stocks = lastTenStocks.sort((a, b) => b.stockId - a.stockId);

        this.stockService.getStocks().subscribe(
          (allStocks: Stock[]) => {
            const allStockIds = new Set(this.stocks.map(stock => stock.stockId));
            const uniqueStocks = allStocks.filter(stock => !allStockIds.has(stock.stockId));
            this.stocks = [...this.stocks, ...uniqueStocks].sort((a, b) => b.stockId - a.stockId);
          },
          (error) => {
            console.error('Error fetching all stock data', error);
          }
        );
      },
      (error) => {
        console.error('Error fetching last ten stocks', error);
      }
    );
    SpinnerServiceService.hideSpinner();
  }



  loadCustomersLazy(event: any) {
    const start = event.first;
    const end = start + event.rows;
    this.visibleCustomerOptions = this.customerOptions.slice(start, end);
  }

  showDialog() {
    this.dialogTitle = 'Add Stock';
    if (this.dialogTitle === 'Add Stock') {
      this.stock.quantity = null;
      this.stock.batchNumber = null;
      this.stock.productTypeName = null;
      this.selectedstockCoverageStartDate = null;
      this.stock.stockCoverageEndDate = null;
      this.hasCoverage = false;
      this.selectedCustomerId = null;
      this.selectedBatchNumber = null;
      this.stock.opportunity.id = null;
      this.selectedQuantity = null;
      this.selectedPrice = null;
      this.selectedPoNumber = null;
      this.selectedstockCoverageStartDate = null;
      this.selectedstockCoverageEndDate = null;
      this.selectedPurchaseDate = null;
      this.selectedStatus = null;
      this.selectedStockOwner = null;
      this.visible = true;
      this.selecteCategory = null;
      this.selectedType = null;
      this.selectedItem = null;

    }
  }

  hasCoverageChange() {
    if (!this.hasCoverage) {
      this.stock.stockCoverageStartDate = null;
      this.stock.stockCoverageEndDate = null;
    }
  }


  closeDialog() {
    this.visible = false;
    this.itemsDialog = false;

    this.dialogTitle = "";
    this.editableStock = null;
    this.selecteCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.stock.productId = null;
    this.stock.categoryName = null;
    this.stock.itemName = null;
    this.stock.productTypeName = null;
    this.stock.customerName = null;
    this.stock.productKind = null;
    this.stock.quantity = null;
    this.selectedOpportunity = null;

    this.stock.quantity = null;
    this.stock.batchNumber = null;
    this.stock.productTypeName = null;
    this.stock.stockCoverageStartDate = null;
    this.stock.stockCoverageEndDate = null;
    this.hasCoverage = false;
    this.selectedCustomerId = null;
    this.selectedBatchNumber = null;
    this.stock.opportunity.id = null;
    this.selectedQuantity = null;
    this.selectedPrice = null;
    this.selectedPoNumber = null;
    this.selectedstockCoverageStartDate = null;
    this.selectedstockCoverageEndDate = null;
    this.selectedPurchaseDate = null;
    this.selectedStatus = null;
    this.selectedStockOwner = null

  }
  handleSelectionChanged(selection: any) {
    this.stock.categoryName = selection.category;
    this.stock.productTypeName = selection.type;
    this.stock.itemName = selection.item;
    this.stock.productId = selection.selectedProductId;

    this.getOpportunities(this.selectedCustomerId, this.stock.productId);
    // console.log('Selected product:', this.stock.productId);

  }
  editableStock: Stock | null;

  populateDropdownGroups() {
    this.categoriesByKind = [
      { label: 'License', items: this.licenseCategories },
      { label: 'Service', items: this.serviceCategories }
    ];
  }

  private transformCategories(data: ProductResponse): SelectItemGroup[] {
    const licenseTypes: { label: string, value: Category }[] = [];
    const serviceTypes: { label: string, value: Category }[] = [];

    // Maps to keep track of categories and their types
    const categoryMap: { [key: string]: Category } = {};

    for (const kind in data) {
      for (const categoryName in data[kind]) {
        const types: Type[] = [];

        for (const typeName in data[kind][categoryName]) {
          // Create or update types for the category
          types.push({
            productType: typeName,
            items: data[kind][categoryName][typeName]
          });
        }

        // Create or update the category map
        if (!categoryMap[categoryName]) {
          categoryMap[categoryName] = {
            category: categoryName,
            types: types
          };
        } else {
          // Merge types if the category already exists
          categoryMap[categoryName].types.push(...types);
        }
      }
    }

    // Separate categories into License and Service
    Object.keys(categoryMap).forEach(categoryName => {
      const category = categoryMap[categoryName];
      if (categoryName.toLowerCase() === 'service') {
        serviceTypes.push({
          label: category.category,
          value: category
        });
      } else {
        licenseTypes.push({
          label: category.category,
          value: category
        });
      }
    });
    this.groupedCategories = [
      {
        label: 'License Categories:',
        items: licenseTypes
      },
      {
        label: 'Service Categories:',
        items: serviceTypes
      }
    ];

    return this.groupedCategories;
  }


  editStock(id: any) {


    this.dialogTitle = "Edit Stock";
    this.editableStock = this.stocks.find(stock => stock.stockId === id);


    if (!this.editableStock) {
      // console.error('Stock not found');
      return;
    }

    // Find the category group that matches the product category
    const categoryGroup = this.categoriesByKind.find(group =>
      group.items.some(item => item.label === this.editableStock.categoryName)
    );


    if (categoryGroup) {
      // Find and set the selected category from the group items
      this.selecteCategory = categoryGroup.items.find(
        item => item.label === this.editableStock.categoryName
      )?.value; // Access the value property of the matched item

      if (this.selecteCategory.category === "Service") {
        this.editableStock.productTypeName = 'service';
      }



      if (this.selecteCategory) {
        // Set types for the matched category
        this.typesByCategory = this.selecteCategory.types;

        // Match and set the selected type by text
        this.selectedType = this.typesByCategory.find(
          type => type.productType === this.editableStock.productTypeName
        );


        // console.log('Selected type:', this.selectedType);



        if (this.selectedType) {
          // Set items for the matched type
          this.itemsByType = this.selectedType.items;

          // Match and set the selected item by text
          this.selectedItem = this.itemsByType.find(
            item => item.item === this.editableStock.itemName
          );

          // console.log('Selected item:', this.selectedItem);

        }
      }
    }
    // console.log(this.editableStock);
    this.selectedCustomerId = this.editableStock.customerId;
    this.selectedBatchNumber = this.editableStock.batchNumber;
    this.stock.opportunity.id = this.editableStock.opportunity?.id || null;
    this.selectedQuantity = this.editableStock.quantity;
    this.selectedPrice = this.editableStock.price;
    this.selectedPoNumber = this.editableStock.poNumber;
    this.selectedstockCoverageStartDate = this.editableStock.stockCoverageStartDate ? new Date(this.editableStock.stockCoverageStartDate) : null;
    this.selectedstockCoverageEndDate = this.editableStock.stockCoverageStartDate ? new Date(this.editableStock.stockCoverageEndDate) : null;
    this.selectedStatus = this.editableStock.status;
    this.stock.productId = this.editableStock.productId;
    this.selectedStockOwner = this.editableStock.stockOwnerId;
    this.selectedPurchaseDate = this.editableStock.purchaseDate ? new Date(this.editableStock.purchaseDate) : null;


    if (this.selectedCustomerId && this.stock.productId) {
      this.getOpportunities(this.selectedCustomerId, this.stock.productId);
    }
    this.visible = true;
  }


  // stocks.component.ts

  updateStock(id: number, stock: CreateStockDTO): void {
    SpinnerServiceService.showSpinner();

    stock.purchaseDate = stock.purchaseDate ? this.formatDate(new Date(stock.purchaseDate)) : null;
    stock.stockCoverageStartDate = stock.stockCoverageStartDate ? this.formatDate(new Date(stock.stockCoverageStartDate)) : null;
    stock.stockCoverageEndDate = stock.stockCoverageEndDate ? this.formatDate(new Date(stock.stockCoverageEndDate)) : null;
    this.stockService.updateStock(id, stock).subscribe(
      (updatedStock: Stock) => {
        const index = this.stocks.findIndex(s => s.stockId === id);
        if (index !== -1) {
          this.stocks[index] = updatedStock;
          this.stocks = [...this.stocks]; // Trigger change detection
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Stock updated successfully' });
        }
        this.closeDialog();
      },
      (error) => {
        console.error('Error updating stock:', error);
      }
    );
    SpinnerServiceService.hideSpinner();

  }

  onStatusChange() {
    if (this.selectedStatus === 2) {
      this.selectedCustomerId = null;
      this.selectedOpportunity = null;
    }
  }
  opportinitiesLookUp: any[] = [];

  getOpportunities(customerId: number, productId: number): void {

    if (customerId == null || productId == null) {
      this.opportunityOptions = null;
      return;
    }


    this.opportunityService.findOpportunitiesByCustomerAndProduct(customerId, productId)
      .subscribe(data => {
        this.opportunityOptions = data;

      });
  }
  customerChange(event: any) {

    this.getOpportunities(this.selectedCustomerId, this.stock.productId);
    this.selectedOpportunity = null;


  }


  viewStockItems(stockId: number) {
    this.stockService.findStockItemsByStockId(stockId).subscribe((data: StockItemDTO[]) => {
      this.stockItems = data;
      this.originalStockItems = JSON.parse(JSON.stringify(data));
      this.itemsDialog = true;
    });
  }
  getStockById(stockId: number) {
    this.stockService.findStockItemsByStockId(stockId).subscribe(
      response => {
        // console.log('stock:', response);
      },
      error => {
        // console.error('Error fetching stock details:', error);
      }
    );
  }

  // sheets functions

  exportExcel() {
    import("xlsx").then(xlsx => {
      const data = this.table.filteredValue ? this.table.filteredValue : this.table.value;
      const worksheet = xlsx.utils.json_to_sheet(data.map(stock => ({
        'Stock Number': stock.batchNumber,
        'Product Kind': stock.productKind,
        'Category': stock.categoryName,
        'Product Type': stock.productTypeName,
        'Item Name': stock.itemName,
        'Quantity': stock.quantity,
        'Available Quantity': stock.availableQuantity,
        'Purchase Date': stock.stockCoverageStartDate,
        'Expiry Date': stock.stockCoverageEndDate,
        'Status': stock.status === 1 ? 'Reserved' : 'On-Hands',
        'Customer': stock.customerName,
        'Opportunity': stock.opportunity?.opportunityName || '', // Ensure opportunityName is included
        'Price': stock.price,
        'PO Number': stock.poNumber
      })));

      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "stocks");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


  exportPdf() {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    const columns = [
      { header: '#', dataKey: 'index' },
      { header: 'Stock Number', dataKey: 'batchNumber' },
      { header: 'Product Kind', dataKey: 'productKind' },
      { header: 'Category', dataKey: 'categoryName' },
      { header: 'Product Type', dataKey: 'productTypeName' },
      { header: 'Item Name', dataKey: 'itemName' },
      { header: 'Quantity', dataKey: 'quantity' },
      { header: 'Available Quantity', dataKey: 'availableQuantity' },
      { header: 'Start Date', dataKey: 'stockCoverageStartDate' },
      { header: 'Coverage Date', dataKey: 'stockCoverageEndDate' },
      { header: 'Status', dataKey: 'status' },
      { header: 'Customer', dataKey: 'customerName' },
      { header: 'Opportunity', dataKey: 'opportunityName' },
      { header: 'Price', dataKey: 'price' },
      { header: 'PO', dataKey: 'poNumber' }
    ];

    const data = this.table.filteredValue ? this.table.filteredValue : this.table.value;

    const rows = data.map((row, index) => ({
      index: index + 1,
      batchNumber: row.batchNumber,
      productKind: row.productKind,
      categoryName: row.categoryName,
      productTypeName: row.productTypeName,
      itemName: row.itemName,
      quantity: row.quantity,
      availableQuantity: row.availableQuantity,
      stockCoverageStartDate: row.stockCoverageStartDate,
      stockCoverageEndDate: row.stockCoverageEndDate,
      status: row.status === 1 ? 'Reserved' : 'On-Hands',
      customerName: row.customerName,
      opportunityName: row.opportunity ? (row.opportunity.opportunityName || 'NON') : 'NON',

      price: row.price,
      poNumber: row.poNumber
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      columnStyles: {
        index: { cellWidth: 26, halign: 'center' },
        batchNumber: { cellWidth: 49, halign: 'center' },
        productKind: { cellWidth: 49, halign: 'center' },
        categoryName: { cellWidth: 67, halign: 'center' },
        productTypeName: { cellWidth: 49, halign: 'center' },
        itemName: { cellWidth: 54, halign: 'center' },
        quantity: { cellWidth: 44, halign: 'center' },
        availableQuantity: { cellWidth: 48.9, halign: 'center' },
        stockPurchaseDate: { cellWidth: 64, halign: 'center' },
        stockExpiryDate: { cellWidth: 64.5, halign: 'center' },
        status: { cellWidth: 59.5, halign: 'center' },
        customerName: { cellWidth: "auto", minCellWidth: 60, halign: 'center' },
        opportunityName: { cellWidth: "auto", halign: 'center' },
        price: { cellWidth: 50, halign: 'center' },
        PO: { cellWidth: 50, halign: 'center' }
      },
      margin: { top: 20 }
    });

    doc.save('Stocks.pdf');
  }

  captureFilteredStockIds(dt: Table) {
    if (dt.filteredValue) {
      this.filteredStockIds = dt.filteredValue.map((stock: any) => stock.stockId);
    } else {
      this.filteredStockIds = [];
    }
    console.log(this.filteredStockIds); // For debugging
  }
  getFilteredStocksItemsForExcel() {
    // If filteredStockIds is null or empty, use all stock IDs from the stocks array
    const stockIdsToUse = this.filteredStockIds && this.filteredStockIds.length > 0
      ? this.filteredStockIds
      : this.stocks.map(stock => stock.stockId);

    if (stockIdsToUse.length > 0) {
      this.stockService.getStockItemsByStockIds(stockIdsToUse).subscribe(
        (response) => {
          console.log('Stock Items for Excel:', response);
          this.exportExcelForStockItems(response);
        },
        (error) => {
          console.error('Error fetching stock items for Excel:', error);
        }
      );
    } else {
      console.warn('No stock items to export for Excel.');
    }
  }

  getFilteredStocksItemsForPdf() {
    // If filteredStockIds is null or empty, use all stock IDs from the stocks array
    const stockIdsToUse = this.filteredStockIds && this.filteredStockIds.length > 0
      ? this.filteredStockIds
      : this.stocks.map(stock => stock.stockId);

    if (stockIdsToUse.length > 0) {
      this.stockService.getStockItemsByStockIds(stockIdsToUse).subscribe(
        (response) => {
          console.log('Stock Items for PDF:', response);
          this.exportPdfForStockItems(response);
        },
        (error) => {
          console.error('Error fetching stock items for PDF:', error);
        }
      );
    } else {
      console.warn('No stock items to export for PDF.');
    }
  }




  exportExcelForStockItems(data: any[]) {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(data.map((stock, index) => ({
        '#': index + 1,  // Row count starts from 1
        'Serial Number': stock.serialNumber,
        'Batch Number': stock.batchNumber,
        'Support Date': stock.itemPurchaseDate,
        'Coverage End Date': stock.itemExpiryDate,
        'Selling Price': stock.sellingPrice,
        'Cost Price': stock.costPrice,
        'Order Number': stock.orderNumber,
        'Customer Name': stock.customerName
      })));

      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "filtered_stocks");
    });
  }




  exportPdfForStockItems(data: any[]) {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    const columns = [
      { header: '#', dataKey: 'rowNumber' },  // Added row count column
      { header: 'Serial Number', dataKey: 'serialNumber' },
      { header: 'Batch Number', dataKey: 'batchNumber' },
      { header: 'Support Date', dataKey: 'itemPurchaseDate' },
      { header: 'Coverage End Date', dataKey: 'itemExpiryDate' },
      { header: 'Selling Price', dataKey: 'sellingPrice' },
      { header: 'Cost Price', dataKey: 'costPrice' },
      { header: 'Order Number', dataKey: 'orderNumber' },
      { header: 'Customer Name', dataKey: 'customerName' }
    ];

    const rows = data.map((row, index) => ({
      rowNumber: index + 1, // Row count starts from 1
      serialNumber: row.serialNumber,
      batchNumber: row.batchNumber,
      itemPurchaseDate: row.itemPurchaseDate,
      itemExpiryDate: row.itemExpiryDate,
      sellingPrice: row.sellingPrice,
      costPrice: row.costPrice,
      orderNumber: row.orderNumber,
      customerName: row.customerName
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      columnStyles: {
        rowNumber: { cellWidth: 40, halign: 'center' }, // Adjusted width for row count
        serialNumber: { cellWidth: 80, halign: 'center' },
        batchNumber: { cellWidth: 80, halign: 'center' },
        itemPurchaseDate: { cellWidth: 110, halign: 'center' },
        itemExpiryDate: { cellWidth: 110, halign: 'center' },
        absoluteItem: { cellWidth: 80, halign: 'center' },
        sellingPrice: { cellWidth: 70, halign: 'center' },
        costPrice: { cellWidth: 70, halign: 'center' },
        orderNumber: { cellWidth: 70, halign: 'center' },
        customerName: { cellWidth: 100, halign: 'center' }
      },
      margin: { top: 20 }
    });

    doc.save('filtered_stocks.pdf');
  }

  get shouldHideHasCoverage(): boolean {
    return !!this.selectedstockCoverageStartDate || !!this.selectedstockCoverageEndDate;
  }

}

